import { render, staticRenderFns } from "./network-logs-display.vue?vue&type=template&id=2c13a01e&scoped=true"
import script from "./network-logs-display.vue?vue&type=script&lang=js"
export * from "./network-logs-display.vue?vue&type=script&lang=js"
import style0 from "./network-logs-display.vue?vue&type=style&index=0&id=2c13a01e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c13a01e",
  null
  
)

export default component.exports